jQuery(document).ready(function () {

    if (jQuery('#appHelp').length) {

        jQuery('.headerNav').append("<span class='help ico'></span>");


        jQuery(".headerNav").on("click", ".help", function () {
            openHelp('appHelp');
        });

    }

});

function openHelp(id) {
    var idModal = jQuery("#" + id);
    idModal.css("display", "block").addClass('in');

    jQuery('body').addClass('modal-open').append("<div class='modal-backdrop fade in'></div> ");

    idModal.on("click", ".close", function () {
        closeHelp(id);
    });
}

function closeHelp(id) {
    var localId = jQuery("#" + id);
    localId.css("display", "none").removeClass('in');
    jQuery('body').removeClass('modal-open');
    jQuery('.modal-backdrop').remove();
}